Controller.$inject = [];

function Controller() {

}

export function HuiPage() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            headerBg: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui hui-page"
                          ng-class="[$huiCtrl.headerBg || 'default']"
                          ng-transclude></div>`;
        }
    };
}